import { Container, LogoContainer } from "./styles";

type Props = {
  name: string;
  info: string;
  logoContainerColor: string;
  LogoIcon: React.ElementType;
  active: boolean;
  statusLabel: string;
};

/** Intro card of a form storage integration: logo, name, whether it's set up, and what it does. */
const StorageIntegrationServiceInfo = ({ name, info, logoContainerColor, LogoIcon, active, statusLabel }: Props) => (
  <Container $active={active}>
    <div className="top">
      <LogoContainer color={logoContainerColor}>
        <LogoIcon />
      </LogoContainer>
      <div className="text">
        <h6>{name}</h6>
        <span className="status">{statusLabel}</span>
      </div>
    </div>
    <p>{info}</p>
  </Container>
);

export default StorageIntegrationServiceInfo;
